var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarroDeLaCompra3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FA862"
    },
    d: "M140.8,329.2c-8,0-15.2-5.6-16.8-13.6l-38.4-180c-1.6-9.6,4-18.4,12.8-20c9.6-1.6,18.4,4,20,12.8 l38.4,180c1.6,9.6-4,18.4-12.8,20C143.2,328.4,142.4,329.2,140.8,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FA862"
    },
    d: "M273.6,329.2c-0.8,0-2.4,0-4,0c-9.6-1.6-15.2-11.2-12.8-20L296,128.4c1.6-9.6,11.2-15.2,20-12.8 c9.6,1.6,15.2,11.2,12.8,20l-38.4,180C288.8,323.6,281.6,329.2,273.6,329.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0FA862"
    },
    d: "M208,325.2c-9.6,0-16-8-16-16.8v-180c0-9.6,6.4-8.8,16-8.8s16,0,16,8.8v180 C224,318,217.6,325.2,208,325.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1AD85A"
    },
    d: "M414.4,134c1.6-4.8,0.8-10.4-2.4-15.2c-3.2-4-8-7.2-13.6-7.2H16.8c-5.6,0-10.4,2.4-13.6,7.2 c-3.2,4.8-4,9.6-2.4,15.2L40,259.6l2.4,7.2l16.8,56c2.4,7.2,8.8,13.6,16,13.6h264c7.2,0,14.4-6.4,16-13.6l16.8-55.2l2.4-7.2 L414.4,134z M60.8,207.6h293.6l-9.6,32H70.4L60.8,207.6z M374.4,143.6l-9.6,32H49.6l-9.6-32H374.4z M88,295.6l-7.2-24h253.6l-7.2,24 H88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19BF55"
    },
    d: "M397.6,119.6H16.8c-5.6,0-10.4,2.4-13.6,6.4c-1.6,1.6-2.4,4-2.4,6.4v0.8L40,259.6l2.4,7.2l16.8,56 c2.4,7.2,8.8,13.6,16,13.6h264c7.2,0,14.4-6.4,16-13.6l16.8-55.2l2.4-7.2l39.2-125.6c0,0,0-0.8,0-1.6c-0.8-2.4-1.6-4-2.4-6.4 C408.8,122,403.2,119.6,397.6,119.6z M334.4,279.6l-7.2,24H88l-7.2-24h2.4l-2.4-8h253.6l-2.4,8H334.4z M354.4,215.6l-9.6,32H70.4 l-9.6-32h2.4l-2.4-8h293.6l-2.4,8H354.4z M374.4,151.6l-9.6,32H49.6l-9.6-32h2.4l-2.4-8h334.4l-2.4,8H374.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#72B1B7"
    },
    d: "M348.8,391.6H66.4c-9.6,0-16.8-6.4-16.8-16s8-16,16.8-16h282.4c9.6,0,16.8,6.4,16.8,16 C365.6,385.2,358.4,391.6,348.8,391.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D9BA5"
    },
    d: "M80.8,391.6h112c0-8-16-24-33.6-32h-60C87.2,367.6,80.8,383.6,80.8,391.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C43700"
    },
    d: "M166.4,394.8c0,24-19.2,45.6-43.2,45.6S80,418,80,394.8c0-24,19.2-43.2,43.2-43.2 S166.4,370.8,166.4,394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9D00"
    },
    d: "M166.4,394.8c0,24-19.2,43.2-43.2,43.2S80,418.8,80,394.8s19.2-46.4,43.2-46.4 C147.2,348.4,166.4,370.8,166.4,394.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5B00"
    },
    cx: 123.2,
    cy: 394.8,
    r: 43.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD4400"
    },
    d: "M92.8,364.4c16.8-16.8,44-16.8,60.8,0s16.8,44,0,60.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F2"
    },
    d: "M123.2,420.4c-14.4,0-25.6-11.2-25.6-25.6s11.2-25.6,25.6-25.6s25.6,11.2,25.6,25.6 C148.8,408.4,137.6,420.4,123.2,420.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFE5"
    },
    d: "M141.6,376.4c9.6,9.6,9.6,26.4,0,36s-26.4,9.6-36,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D9BA5"
    },
    d: "M238.4,391.6h112c0-8-16-24-33.6-32H256C245.6,367.6,238.4,383.6,238.4,391.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C43700"
    },
    d: "M324,394.8c0,24-19.2,45.6-43.2,45.6s-43.2-22.4-43.2-45.6c0-24,19.2-43.2,43.2-43.2 S324,370.8,324,394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9D00"
    },
    d: "M324,394.8c0,24-19.2,43.2-43.2,43.2s-43.2-19.2-43.2-43.2s19.2-46.4,43.2-46.4 C304.8,348.4,324,370.8,324,394.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5B00"
    },
    cx: 281.6,
    cy: 394.8,
    r: 43.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD4400"
    },
    d: "M251.2,364.4c16.8-16.8,44-16.8,60.8,0s16.8,44,0,60.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF0F2"
    },
    d: "M281.6,420.4c-14.4,0-25.6-11.2-25.6-25.6s11.2-25.6,25.6-25.6s25.6,11.2,25.6,25.6 C306.4,408.4,295.2,420.4,281.6,420.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CADFE5"
    },
    d: "M299.2,376.4c9.6,9.6,9.6,26.4,0,36s-26.4,9.6-36,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B5A89"
    },
    d: "M496,71.6c0,8.8-7.2,16-16,16h-72c-8.8,0-16-7.2-16-16l0,0c0-8.8,7.2-16,16-16h72 C488.8,55.6,496,62.8,496,71.6L496,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18456D"
    },
    d: "M407.2,55.6c-7.2,0-13.6,6.4-15.2,12.8c2.4,7.2,7.2,11.2,15.2,11.2h72c7.2,0,14.4-4.8,16.8-12 c-2.4-8-8.8-12-16.8-12H407.2z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarroDeLaCompra3);
export default __webpack_public_path__ + "static/media/carro-de-la-compra-3.34553c807b3a9e9c3e43cf7b111fa406.svg";
export { ForwardRef as ReactComponent };